export default [
	{
		value: '媒体/品牌',
		label: '媒体/品牌',
		children: [
			{
				value: '爱图仕',
				label: '爱图仕'
			},
			{
				value: '百诺',
				label: '百诺'
			},
			{
				value: '德塔',
				label: '德塔'
			},
			{
				value: '雷克沙',
				label: '雷克沙'
			},
			{
				value: '腾龙',
				label: '腾龙'
			}
		]
	}
];
// export default [
// 	{
// 		value: '媒体/品牌',
// 		label: '媒体/品牌',
// 		children: [
// 			{
// 				value: '摄影之友',
// 				label: '摄影之友'
// 			},
// 			{
// 				value: '数字尾巴',
// 				label: '数字尾巴'
// 			},
// 			{
// 				value: '千途网',
// 				label: '千途网'
// 			},
// 			{
// 				value: '松下',
// 				label: '松下'
// 			},
// 			{
// 				value: '明基旗舰店',
// 				label: '明基旗舰店'
// 			}
// 		]
// 	},
// 	{
// 		value: '江苏俱乐部',
// 		label: '江苏俱乐部',
// 		children: [
// 			{
// 				value: '无锡全友',
// 				label: '无锡全友'
// 			},
// 			{
// 				value: '常熟亚亚',
// 				label: '常熟亚亚'
// 			},
// 			{
// 				value: '扬州天天乐',
// 				label: '扬州天天乐'
// 			},
// 			{
// 				value: '镇江先锋',
// 				label: '镇江先锋'
// 			},
// 			{
// 				value: '盐城九州',
// 				label: '盐城九州'
// 			},
// 			{
// 				value: '淮安佳摄',
// 				label: '淮安佳摄'
// 			},
// 			{
// 				value: '苏州亚亚',
// 				label: '苏州亚亚'
// 			},
// 			{
// 				value: '常州今日信合',
// 				label: '常州今日信合'
// 			}
// 		]
// 	},
// 	{
// 		value: '山东俱乐部',
// 		label: '山东俱乐部',
// 		children: [
// 			{
// 				value: '济南尼文',
// 				label: '济南尼文'
// 			},
// 			{
// 				value: '威海鸿盛',
// 				label: '威海鸿盛'
// 			},
// 			{
// 				value: '德州影友',
// 				label: '德州影友'
// 			},
// 			{
// 				value: '烟台绿森',
// 				label: '烟台绿森'
// 			},
// 			{
// 				value: '淄博宏海',
// 				label: '淄博宏海'
// 			},
// 			{
// 				value: '东营贝斯特',
// 				label: '东营贝斯特'
// 			},
// 			{
// 				value: '日照盛州',
// 				label: '日照盛州'
// 			},
// 			{
// 				value: '潍坊启运',
// 				label: '潍坊启运'
// 			},
// 			{
// 				value: '临沂神州',
// 				label: '临沂神州'
// 			},
// 			{
// 				value: '青州友乐',
// 				label: '青州友乐'
// 			},
// 			{
// 				value: '青岛永盛',
// 				label: '青岛永盛'
// 			}
// 		]
// 	},
// 	{
// 		value: '辽宁俱乐部',
// 		label: '辽宁俱乐部',
// 		children: [
// 			{
// 				value: '锦州维国',
// 				label: '锦州维国'
// 			},
// 			{
// 				value: '大连深蓝',
// 				label: '大连深蓝'
// 			},
// 			{
// 				value: '鞍山鑫和',
// 				label: '鞍山鑫和'
// 			},
// 			{
// 				value: '丹东视界映像',
// 				label: '丹东视界映像'
// 			},
// 			{
// 				value: '辽阳博研',
// 				label: '辽阳博研'
// 			}
// 		]
// 	},
// 	{
// 		value: '吉林俱乐部',
// 		label: '吉林俱乐部',
// 		children: [
// 			{
// 				value: '长春金胜',
// 				label: '长春金胜'
// 			},
// 			{
// 				value: '吉林新文彩',
// 				label: '吉林新文彩'
// 			}
// 		]
// 	},
// 	{
// 		value: '河北俱乐部',
// 		label: '河北俱乐部',
// 		children: [
// 			{
// 				value: '邯郸老薛',
// 				label: '邯郸老薛'
// 			},
// 			{
// 				value: '保定今日吉瑞',
// 				label: '保定今日吉瑞'
// 			},
// 			{
// 				value: '石家庄恒威',
// 				label: '石家庄恒威'
// 			},
// 			{
// 				value: '唐山新视听',
// 				label: '唐山新视听'
// 			},
// 			{
// 				value: '沧州文脉',
// 				label: '沧州文脉'
// 			},
// 			{
// 				value: '秦皇岛思予',
// 				label: '秦皇岛思予'
// 			}
// 		]
// 	},
// 	{
// 		value: '北京俱乐部',
// 		label: '北京俱乐部',
// 		children: [
// 			{
// 				value: '北京锐意',
// 				label: '北京锐意'
// 			},
// 			{
// 				value: '北京雅奇',
// 				label: '北京雅奇'
// 			},
// 			{
// 				value: '北京卓美',
// 				label: '北京卓美'
// 			}
// 		]
// 	},
// 	{
// 		value: '河南俱乐部',
// 		label: '河南俱乐部',
// 		children: [
// 			{
// 				value: '平顶山新思维',
// 				label: '平顶山新思维'
// 			},
// 			{
// 				value: '信阳百斯特',
// 				label: '信阳百斯特'
// 			},
// 			{
// 				value: '南阳光影数码',
// 				label: '南阳光影数码'
// 			},
// 			{
// 				value: '安阳歌群',
// 				label: '安阳歌群'
// 			},
// 			{
// 				value: '郑州星辉',
// 				label: '郑州星辉'
// 			},
// 			{
// 				value: '焦作众邦',
// 				label: '焦作众邦'
// 			},
// 			{
// 				value: '濮阳青恋子',
// 				label: '濮阳青恋子'
// 			},
// 			{
// 				value: '新乡倚天',
// 				label: '新乡倚天'
// 			}
// 		]
// 	},
// 	{
// 		value: '安徽俱乐部',
// 		label: '安徽俱乐部',
// 		children: [
// 			{
// 				value: '合肥1826',
// 				label: '合肥1826'
// 			}
// 		]
// 	},
// 	{
// 		value: '天津俱乐部',
// 		label: '天津俱乐部',
// 		children: [
// 			{
// 				value: '天津亨昌瑞祥',
// 				label: '天津亨昌瑞祥'
// 			}
// 		]
// 	},
// 	{
// 		value: '陕西俱乐部',
// 		label: '陕西俱乐部',
// 		children: [
// 			{
// 				value: '榆林魅力',
// 				label: '榆林魅力'
// 			},
// 			{
// 				value: '西安小钟',
// 				label: '西安小钟'
// 			},
// 			{
// 				value: '宝鸡品欢',
// 				label: '宝鸡品欢'
// 			}
// 		]
// 	},
// 	{
// 		value: '山西俱乐部',
// 		label: '山西俱乐部',
// 		children: [
// 			{
// 				value: '阳泉五一',
// 				label: '阳泉五一'
// 			},
// 			{
// 				value: '大同智龙',
// 				label: '大同智龙'
// 			},
// 			{
// 				value: '太原奥康',
// 				label: '太原奥康'
// 			},
// 			{
// 				value: '运城凤凰',
// 				label: '运城凤凰'
// 			}
// 		]
// 	},
// 	{
// 		value: '宁夏俱乐部',
// 		label: '宁夏俱乐部',
// 		children: [
// 			{
// 				value: '宁夏华鹏',
// 				label: '宁夏华鹏'
// 			},
// 			{
// 				value: '银川新艺典',
// 				label: '银川新艺典'
// 			}
// 		]
// 	},
// 	{
// 		value: '内蒙古俱乐部',
// 		label: '内蒙古俱乐部',
// 		children: [
// 			{
// 				value: '包头玖明',
// 				label: '包头玖明'
// 			}
// 		]
// 	},
// 	{
// 		value: '甘肃俱乐部',
// 		label: '甘肃俱乐部',
// 		children: [
// 			{
// 				value: '兰州鹰图',
// 				label: '兰州鹰图'
// 			}
// 		]
// 	},
// 	{
// 		value: '广东俱乐部',
// 		label: '广东俱乐部',
// 		children: [
// 			{
// 				value: '广州情迷',
// 				label: '广州情迷'
// 			},
// 			{
// 				value: '深圳函授学院',
// 				label: '深圳函授学院'
// 			},
// 			{
// 				value: '深圳深鸿',
// 				label: '深圳深鸿'
// 			},
// 			{
// 				value: '深圳风光摄协',
// 				label: '深圳风光摄协'
// 			},
// 			{
// 				value: '深圳视界',
// 				label: '深圳视界'
// 			},
// 			{
// 				value: '深圳i摄',
// 				label: '深圳i摄'
// 			}
// 		]
// 	},
// 	{
// 		value: '广西俱乐部',
// 		label: '广西俱乐部',
// 		children: [
// 			{
// 				value: '桂林新广角',
// 				label: '桂林新广角'
// 			},
// 			{
// 				value: '柳州贝利',
// 				label: '柳州贝利'
// 			},
// 			{
// 				value: '南宁君人庆',
// 				label: '南宁君人庆'
// 			}
// 		]
// 	},
// 	{
// 		value: '湖北俱乐部',
// 		label: '湖北俱乐部',
// 		children: [
// 			{
// 				value: '武汉金明华',
// 				label: '武汉金明华'
// 			},
// 			{
// 				value: '武汉洛宜',
// 				label: '武汉洛宜'
// 			}
// 		]
// 	},
// 	{
// 		value: '湖南俱乐部',
// 		label: '湖南俱乐部',
// 		children: [
// 			{
// 				value: '吉首爱看远大',
// 				label: '吉首爱看远大'
// 			},
// 			{
// 				value: '郴州艺佳',
// 				label: '郴州艺佳'
// 			}
// 		]
// 	},
// 	{
// 		value: '四川俱乐部',
// 		label: '四川俱乐部',
// 		children: [
// 			{
// 				value: '成都捷成',
// 				label: '成都捷成'
// 			}
// 		]
// 	},
// 	{
// 		value: '福建俱乐部',
// 		label: '福建俱乐部',
// 		children: [
// 			{
// 				value: '福州大扬',
// 				label: '福州大扬'
// 			},
// 			{
// 				value: '厦门银城影像',
// 				label: '厦门银城影像'
// 			},
// 			{
// 				value: '厦门一羽影像',
// 				label: '厦门一羽影像'
// 			},
// 			{
// 				value: '厦门鹭圆',
// 				label: '厦门鹭圆'
// 			},
// 			{
// 				value: '泉州亿盛兴',
// 				label: '泉州亿盛兴'
// 			}
// 		]
// 	},
// 	{
// 		value: '浙江俱乐部',
// 		label: '浙江俱乐部',
// 		children: [
// 			{
// 				value: '杭州华厦',
// 				label: '杭州华厦'
// 			},
// 			{
// 				value: '杭州启摄',
// 				label: '杭州启摄'
// 			},
// 			{
// 				value: '台州方升',
// 				label: '台州方升'
// 			},
// 			{
// 				value: '嘉兴亿鑫',
// 				label: '嘉兴亿鑫'
// 			},
// 			{
// 				value: '宁波新方特',
// 				label: '宁波新方特'
// 			},
// 			{
// 				value: '慈溪品色',
// 				label: '慈溪品色'
// 			},
// 			{
// 				value: '温州镜观',
// 				label: '温州镜观'
// 			},
// 			{
// 				value: '温州鸿运',
// 				label: '温州鸿运'
// 			}
// 		]
// 	},
// 	{
// 		value: '云南俱乐部',
// 		label: '云南俱乐部',
// 		children: [
// 			{
// 				value: '大理金泰',
// 				label: '大理金泰'
// 			},
// 			{
// 				value: '昆明新世界',
// 				label: '昆明新世界'
// 			},
// 			{
// 				value: '曲靖锦泰佳',
// 				label: '曲靖锦泰佳'
// 			}
// 		]
// 	},
// 	{
// 		value: '江西俱乐部',
// 		label: '江西俱乐部',
// 		children: [
// 			{
// 				value: '南昌幸福数码',
// 				label: '南昌幸福数码'
// 			},
// 			{
// 				value: '南昌天强数码',
// 				label: '南昌天强数码'
// 			}
// 		]
// 	}
// ];
